// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"30acceae","60":"0c3eda2d","143":"dbacf304","545":"b3ff3c25","598":"7dbe0c2d","920":"f3cc429f"}[chunkId] + ".chunk.css";
};